import $api from '@/shared/services/api'

// Requisição de dashboard em voo — evita que o shell e a tela de Início
// disparem a mesma carga em paralelo (GCK-20834/QA)
let requisicaoEmAndamento = null

// GCK-20830: dashboard do portal — payload agregado (resumo do período,
// cobranças, vendas, assinaturas e chamados). Cacheado em memória; o seletor
// de mês recarrega apenas quando o período muda.
export default {
    namespaced: true,
    state: {
        dashboard: null,
        periodo: null,
        // GCK-20834: painel do widget de ajuda (FAB) — navbar e central de
        // chamados também acionam a abertura
        ajudaAberta: false,
    },
    getters: {
        pegaDashboard(state){
            return state.dashboard
        },
        // Cobranças em aberto (vencidas + próximas) — fonte do sino de notificações
        pegaNotificacoes(state){
            if(!state.dashboard || !state.dashboard.cobrancas){
                return []
            }
            const vencidas = (state.dashboard.cobrancas.vencidas || []).map(c => ({ ...c, vencida: true }))
            const proximas = (state.dashboard.cobrancas.proximas || []).map(c => ({ ...c, vencida: false }))
            return vencidas.concat(proximas)
        },
    },
    mutations: {
        atualizaDashboard(state, dados){
            state.dashboard = dados.dashboard
            state.periodo = dados.periodo
        },
        alternaAjuda(state, aberta){
            state.ajudaAberta = aberta === undefined ? !state.ajudaAberta : !!aberta
        },
    },
    actions: {
        async carregaDashboard({ commit, state }, periodo = {}){
            const chave = `${periodo.mes || ''}-${periodo.ano || ''}`
            if(state.dashboard && state.periodo === chave){
                return state.dashboard
            }
            const parametros = {}
            if(periodo.mes){
                parametros.mes = periodo.mes
            }
            if(periodo.ano){
                parametros.ano = periodo.ano
            }
            requisicaoEmAndamento = $api.get('/area_cliente/sistema/dashboard', parametros, false)
            let retorno
            try{
                retorno = await requisicaoEmAndamento
            }finally{
                requisicaoEmAndamento = null
            }
            if(retorno.status == 'success'){
                commit('atualizaDashboard', { dashboard: retorno.data, periodo: chave })
            }
            return retorno.status == 'success' ? retorno.data : null
        },
        // O dashboard alimenta o sino de notificações (cobranças em aberto) em
        // TODAS as telas do portal, mas só o Início o carrega. Fora dele — ou
        // num refresh direto numa tela interna — o shell garante a carga.
        // Espera um tick para não competir com a tela de Início, que carrega
        // com o período do seletor.
        async garanteDashboard({ state, dispatch }){
            await new Promise((resolve) => setTimeout(resolve, 0))
            if(state.dashboard || requisicaoEmAndamento){
                return state.dashboard
            }
            return dispatch('carregaDashboard')
        },
    },
}
